export class AppSettings {
  public static SESSION_TIMEOUT = 10;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/app.settings.ts